import { api } from '@/api';
import { createAsyncThunk } from '@/store/utils';
import type { CardDTO } from '@/types/dto/agent';

export const getCards = createAsyncThunk<CardDTO[] | undefined>(
  'cards/getCards',
  async () => {
    return (await api.agentApi.Cards_GetPlaces()).data.items;
  }
);
